import { pickField } from "@/utility/fclReportFieldUtils";
import {
    clipText,
    dateReportCol,
    fileRefLinkCell,
    pickSort,
    reportCol,
} from "./importReportColumnUtils";

const formatLocation = (row, nameKeys, customizedKeys, codeKeys) => {
    const name = pickField(row, nameKeys);
    const customized = pickField(row, customizedKeys);
    const code = pickField(row, codeKeys);

    if (name && /\[[^\]]+\]/.test(name)) return String(name).trim();
    const display = customized || name;
    if (!display) return "";
    if (code && !String(display).includes("[")) return `${display} [${code}]`;
    return String(display).trim();
};

/** Matches Arrival Notice List layout — HBL No through ETA. */
export const IMPORT_ARRIVAL_NOTICE_PRE_ALERT_LIST_COLUMNS = [
    reportCol({
        key: "hblNo",
        label: "HBL No",
        width: 130,
        sticky: "left",
        render: (row) =>
            fileRefLinkCell(
                pickField(row, ["hblNo", "HblNo", "hblNumber", "HblNumber", "HBLNumber"])
            ),
        getTooltip: (row) =>
            pickField(row, ["hblNo", "HblNo", "hblNumber", "HblNumber", "HBLNumber"]) || "",
        sortValue: (row) =>
            pickSort(row, ["hblNo", "HblNo", "hblNumber", "HblNumber", "HBLNumber"]),
    }),
    dateReportCol({
        key: "blDate",
        label: "B/L Date",
        width: 130,
        fieldKeys: ["blDate", "BlDate", "BLDate"],
    }),
    reportCol({
        key: "customer",
        label: "Customer",
        width: 220,
        render: (row) => clipText(pickField(row, ["customer", "Customer"])),
        getTooltip: (row) => pickField(row, ["customer", "Customer"]) || "",
        sortValue: (row) => pickSort(row, ["customer", "Customer"]),
    }),
    reportCol({
        key: "salesPerson",
        label: "SalesPerson",
        width: 130,
        render: (row) =>
            clipText(
                pickField(row, [
                    "salesPerson",
                    "SalesPerson",
                    "salesPersonName",
                    "SalesPersonName",
                ])
            ),
        sortValue: (row) =>
            pickSort(row, ["salesPerson", "SalesPerson", "salesPersonName", "SalesPersonName"]),
    }),
    reportCol({
        key: "carrier",
        label: "Carrier",
        width: 175,
        render: (row) =>
            clipText(pickField(row, ["carrier", "Carrier", "carrierName", "CarrierName"])),
        getTooltip: (row) => pickField(row, ["carrier", "Carrier"]) || "",
        sortValue: (row) => pickSort(row, ["carrier", "Carrier", "carrierName", "CarrierName"]),
    }),
    reportCol({
        key: "origin",
        label: "Origin",
        width: 175,
        render: (row) =>
            clipText(
                formatLocation(
                    row,
                    ["origin", "Origin"],
                    ["originCustomized", "OriginCustomized", "origin_Customized", "Origin_Customized"],
                    ["originCode", "OriginCode"]
                )
            ),
        getTooltip: (row) =>
            formatLocation(
                row,
                ["origin", "Origin"],
                ["originCustomized", "OriginCustomized", "origin_Customized", "Origin_Customized"],
                ["originCode", "OriginCode"]
            ),
        sortValue: (row) =>
            formatLocation(
                row,
                ["origin", "Origin"],
                ["originCustomized", "OriginCustomized", "origin_Customized", "Origin_Customized"],
                ["originCode", "OriginCode"]
            ).toLowerCase(),
    }),
    reportCol({
        key: "pol",
        label: "POL",
        width: 175,
        render: (row) =>
            clipText(
                formatLocation(
                    row,
                    ["pol", "POL"],
                    ["polCustomized", "PolCustomized"],
                    ["polCode", "PolCode"]
                )
            ),
        getTooltip: (row) =>
            formatLocation(row, ["pol", "POL"], ["polCustomized", "PolCustomized"], ["polCode", "PolCode"]),
        sortValue: (row) =>
            formatLocation(row, ["pol", "POL"], ["polCustomized", "PolCustomized"], ["polCode", "PolCode"]).toLowerCase(),
    }),
    reportCol({
        key: "pod",
        label: "POD",
        width: 175,
        render: (row) =>
            clipText(
                formatLocation(
                    row,
                    ["pod", "POD"],
                    ["podCustomized", "PodCustomized"],
                    ["podCode", "PodCode"]
                )
            ),
        getTooltip: (row) =>
            formatLocation(row, ["pod", "POD"], ["podCustomized", "PodCustomized"], ["podCode", "PodCode"]),
        sortValue: (row) =>
            formatLocation(row, ["pod", "POD"], ["podCustomized", "PodCustomized"], ["podCode", "PodCode"]).toLowerCase(),
    }),
    reportCol({
        key: "dest",
        label: "Dest.",
        width: 175,
        render: (row) =>
            clipText(
                formatLocation(
                    row,
                    ["dest", "Dest", "destination", "Destination"],
                    ["destCustomized", "DestCustomized"],
                    ["destCode", "DestCode"]
                )
            ),
        getTooltip: (row) =>
            formatLocation(
                row,
                ["dest", "Dest", "destination", "Destination"],
                ["destCustomized", "DestCustomized"],
                ["destCode", "DestCode"]
            ),
        sortValue: (row) =>
            formatLocation(
                row,
                ["dest", "Dest", "destination", "Destination"],
                ["destCustomized", "DestCustomized"],
                ["destCode", "DestCode"]
            ).toLowerCase(),
    }),
    dateReportCol({
        key: "ets",
        label: "ETS",
        width: 120,
        fieldKeys: ["ets", "ETS", "etd", "ETD"],
    }),
    dateReportCol({
        key: "eta",
        label: "ETA",
        width: 120,
        fieldKeys: ["eta", "ETA", "etapod", "ETAPOD"],
    }),
];

/** @deprecated Use IMPORT_ARRIVAL_NOTICE_PRE_ALERT_LIST_COLUMNS */
export const IMPORT_ARRIVAL_NOTICE_PRE_ALERT_COLUMNS = IMPORT_ARRIVAL_NOTICE_PRE_ALERT_LIST_COLUMNS;
